import React from 'react';
import { styles } from './InfinitePagination.css';
import { ProgressBar } from '@jbhi-fi/components/src/ProgressBar/ProgressBar';

export interface InfinitePaginationProps {
  currentItemsCount: number;
  totalItemsCount: number;
  showProgressText?: boolean;
  showProgressBar?: boolean;
  className?: string;
}

export const InfinitePagination: React.FC<InfinitePaginationProps> = ({
  showProgressText = false,
  showProgressBar = false,
  currentItemsCount,
  totalItemsCount,
  className,
}) => {
  currentItemsCount = currentItemsCount <= totalItemsCount ? currentItemsCount : totalItemsCount;
  return (
    <div className={className}>
      <p className={styles.progressText({ showProgressText, showProgressBar })}>
        Showing {currentItemsCount} of {totalItemsCount}
      </p>
      <ProgressBar
        className={styles.progressBar({ showProgressBar })}
        currentItemsCount={currentItemsCount}
        totalItemsCount={totalItemsCount}
      />
    </div>
  );
};
